module.exports = __webpack_public_path__ + "img/IMG_5002_L_Black.7ee9c5aa.jpg";